<section class="auth-actions" aria-labelledby="reset-title">
  <img class="logo" src="assets/default-images/default-logo.png" alt="Buurtvervoer" />
  <h1 id="reset-title">{{ mode() === 'verifyEmail' ? 'E-mailadres verifiëren' : 'Nieuw wachtwoord instellen' }}</h1>
  @if (state() === 'loading') {
    <p role="status">{{ mode() === 'verifyEmail' ? 'Verificatielink controleren...' : 'Resetlink controleren...' }}</p>
  }
  @if (error()) {
    <p role="alert">{{ error() }}</p>
  }
  @if (state() === 'ready') {
    <p class="email">{{ email() }}</p>
    <form (ngSubmit)="save()">
      <mat-form-field>
        <mat-label>Nieuw wachtwoord</mat-label>
        <input
          matInput
          [formControl]="password"
          [type]="showPassword() ? 'text' : 'password'"
          autocomplete="new-password"
          [readonly]="saving()"
          aria-describedby="password-requirements"
        />
        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="showPassword.set(!showPassword())"
          [attr.aria-label]="showPassword() ? 'Wachtwoord verbergen' : 'Wachtwoord laten zien'"
          [matTooltip]="showPassword() ? 'Wachtwoord verbergen' : 'Wachtwoord laten zien'"
        >
          <mat-icon>{{ showPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>
      <div id="password-requirements" aria-live="polite">
        @if (passwordStrength().preThreshold) {
          <p>Minimaal {{ passwordStrength().minCheckLength }} tekens.</p>
        } @else {
          <p>
            Sterkte: <strong>{{ passwordStrength().isStrong ? 'Sterk' : 'Zwak' }}</strong>
          </p>
        }
        @if (validating()) {
          <p role="status">Wachtwoord controleren...</p>
        }
        <ul>
          @for (requirement of requirements(); track requirement.text) {
            <li>
              <mat-icon aria-hidden="true">{{ requirement.met ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
              <span>{{ requirement.text }}: {{ requirement.met ? 'voldaan' : 'nog niet voldaan' }}</span>
            </li>
          }
        </ul>
      </div>
      @if (error() && !validation()) {
        <button mat-button type="button" (click)="checkPassword()" [disabled]="validating() || saving()">
          Opnieuw controleren
        </button>
      }
      <button
        mat-flat-button
        class="primary-color"
        type="submit"
        [disabled]="saving() || validating() || !passwordStrength().isStrong || !password.valid"
      >
        {{ saving() ? 'Opslaan...' : 'Wachtwoord opslaan' }}
      </button>
    </form>
  }
  @if (state() === 'success') {
    <p role="status">
      {{
        mode() === 'verifyEmail'
          ? 'Je e-mailadres is succesvol geverifieerd.'
          : 'Je wachtwoord is gewijzigd. Je kunt nu inloggen met je nieuwe wachtwoord.'
      }}
    </p>
    @if (redirecting()) {
      <button mat-flat-button class="primary-color" type="button" (click)="continue()">Ga verder</button>
      <p>Je wordt over {{ countdown() }} seconden doorgestuurd...</p>
    }
  }
  @if (state() === 'error' && mode() === 'resetPassword') {
    <a mat-button routerLink="/login/reset-password">Nieuwe resetlink aanvragen</a>
  }
  <button mat-button type="button" (click)="continue()"><mat-icon>arrow_back</mat-icon>Terug naar inloggen</button>
</section>
